import * as GlassWare from 'src/util/icons/glassware'

import Field from '../Field'
import React from 'react'
import { ServingVessel } from 'src/types/schema/graphql'
import classNames from 'classnames'
import { useBrewDetailStore } from '../../state/useBrewDetailStore'
import { parseLiquidColorSlug } from '../../util/helpers/parseLiquidColorSlug'

const ServingVessels: React.FC = () => {
    const { servingVessels, srm, productData } = useBrewDetailStore()
    const anySrm = srm || productData?.style?.srmMin
    const color = productData?.color ? parseLiquidColorSlug(productData?.color) : 'gold'
    const fillColor = anySrm ? parseLiquidColorSlug(`srm-${anySrm}`) : color

    const brewerServingVessels =
        servingVessels?.filter((item) => item !== ServingVessel.None)?.length > 0
            ? servingVessels?.filter((item) => item !== ServingVessel.None)
            : null

    const anyServingVessels = brewerServingVessels || productData?.style?.servingVessels || ['--']

    const containerClasses = classNames(
        'flex items-center gap-1 py-1 pr-4 text-base rounded-full',
        !brewerServingVessels && !productData?.style?.servingVessels
            ? 'bg-white'
            : 'pl-2 bg-gray-100'
    )
    const jsxServingVessels = anyServingVessels.map((vessel) => {
        const iconSlug = `Glassware${vessel.toString().replace(/[_]/g, '')}`
        const CustomIcon = iconSlug in GlassWare ? GlassWare[iconSlug] : () => <></>
        return (
            <div key={vessel} className={containerClasses}>
                <div className='brew-modal-vessel-svg-wrapper'>
                    <CustomIcon fillColor={fillColor} />
                </div>
                <div className='text-gray-500'>{String(vessel).replace(/_/g, ' ')}</div>
            </div>
        )
    })

    return (
        jsxServingVessels && (
            <Field title='Recommended Glassware' gap='2'>
                {jsxServingVessels?.length ? jsxServingVessels : '--'}
            </Field>
        )
    )
}

export default ServingVessels
